import { render, staticRenderFns } from "./ImageToolBar.vue?vue&type=template&id=4b9cb25a&scoped=true"
import script from "./ImageToolBar.vue?vue&type=script&lang=js"
export * from "./ImageToolBar.vue?vue&type=script&lang=js"
import style0 from "./ImageToolBar.vue?vue&type=style&index=0&id=4b9cb25a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9cb25a",
  null
  
)

export default component.exports